module.exports = __webpack_public_path__ + "assets/qianzhang.28df9c08acac3dd1b258a21c6376a4ec.png";